import _extends from "@babel/runtime/helpers/extends";

/** @jsx jsx */
import { forwardRef } from 'react';
import { css, jsx } from '@emotion/core';
import { B100, N20, N50A, N60A } from '@atlaskit/theme/colors';
import { TableBodyRow } from '../TableRow';
const rankingStyles = css({
  display: 'block'
});
const elevationStyle = `var(--ds-overlay, ${`0 20px 32px -8px ${N50A}, 0 0 1px ${N60A}`})`;
/**
 * TODO: Pass the props here to get particular theme for the table
 * Skipping it for now as it may impact migration as util-shared-styles does not support this feature
 */

const rankingItemStyles = css({
  backgroundColor: `var(--ds-background-subtleNeutral-resting, ${N20})`,
  boxShadow: elevationStyle,
  borderRadius: '2px'
});
const draggableStyles = css({
  '&:focus': {
    outlineStyle: 'solid',
    outlineColor: `var(--ds-border-focus, ${B100})`
  },
  outlineWidth: '2px'
});
export const RankableTableBodyRow = /*#__PURE__*/forwardRef(({
  isRanking,
  isRankingItem,
  ...props
}, ref) => {
  return jsx(TableBodyRow, _extends({
    css: [isRanking && rankingStyles, isRankingItem && rankingItemStyles, draggableStyles],
    ref: ref
  }, props));
});